import { useToastController } from 'bootstrap-vue-next';
import { useI18n } from 'vue-i18n';

import { useFastedApi } from './fasted_api';

export default function useNotifications() {
  const { getErrorMessage } = useFastedApi();
  const { t } = useI18n({ useScope: 'global' });

  const { show } = useToastController();

  const notifyError = (text, title, href = undefined, noAutoHide = false) => {
    show?.({
      props: {
        title: title || t('JTADM_NOTIFICATIONS_ERROR'),
        body: text || t('JTADM_NOTIFICATIONS_UNKNOWN'),
        variant: 'danger',
        'no-auto-hide': noAutoHide,
        href,
      },
    });
  };

  const showLoginNotification = () => {
    notifyError(t('JTADM_LAYOUT_CLICK_HERE'), t('JTADM_LAYOUT_NO_DATA'), '/logout', true);
  };

  const notifyNetworkError = (error) => notifyError(getErrorMessage(error.networkError?.result));

  const notifyWarning = (body, title) => {
    show?.({
      props: {
        title,
        body,
        variant: 'warning',
      },
    });
  };

  const notifySuccess = (body, title) => {
    show?.({
      props: {
        title,
        body,
        variant: 'success',
      },
    });
  };

  return {
    notifyError,
    showLoginNotification,
    notifyNetworkError,
    notifyWarning,
    notifySuccess,
  };
}
